import React from 'react';

import { Link, Text } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../shared/types';

import { useDecisionMakerResponse } from './hooks/useDecisionMakerResponse';

export const DecisionMakerResponse: React.FC<{ response: NormalizedDecisionMaker['response'] }> = ({ response }) => {
	const {
		data: { responseText, readMoreLink, isTruncated, responseRef },
		actions: { trackReadFullDMResponseClick },
	} = useDecisionMakerResponse(response);

	return (
		<>
			<Text
				ref={responseRef}
				variant="body"
				className="font-serif mb-1 line-clamp-2 overflow-hidden text-ellipsis italic [overflow-wrap:anywhere]"
			>
				&ldquo;{responseText}&rdquo;
			</Text>

			{isTruncated && (
				<Link
					href={readMoreLink}
					size="small"
					className="block"
					data-qa="read-dm-response"
					variant="secondary"
					onClick={trackReadFullDMResponseClick}
				>
					Read full response
				</Link>
			)}
		</>
	);
};
